<template>
    <div>
        <div class="page-top mb-3 mt-4 d-flex justify-content-between align-items-center w-100">
            <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                <li v-for="(tab, index) in tabs" :key="index" class="nav-item" v-if="shouldShowTab(tab.name)">
                    <a
                            :class="{ active: isActiveTab(tab.name) }"
                            @click="setToggle(tab.name)"
                            class="nav-link cursor-pointer"
                    >
                        {{ tab.label }}
                    </a>
                </li>
            </ul>
        </div>
        <template v-if="activeTabs.length > 0">
            <component
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :is="tab.component"
                    v-if="isActiveTab(tab.name) && tab.condition"
            />
        </template>

        <template v-else>
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    import PendingBatch from "./ReconTransactionsComponent.vue";
    import InProcessBatch from "./BatchHitReconComponent.vue";
    import EasyPaisaBatch from "./EasyPaisaReconComponent";
    import FincaBatch from "./FincaReconComponent";

    export default {
        data() {
            return {
                activeTabs: [],
                firstActiveTab: null, // Keep track of the first tab with true permissions
                tabs: [
                    { name: "pendingBatch", label: "Pending Batch", component: "PendingBatch", condition: null },
                    { name: "inProcessBatch", label: "Finca In Process Batch", component: "InProcessBatch", condition: null },
                    { name: "easyPaisaBatch", label: "Easy Paisa Batch", component: "EasyPaisaBatch", condition: null },
                    { name: "fincaBatch", label: "Finca Batch", component: "FincaBatch", condition: null },
                ],
            };
        },
        components: {
            PendingBatch,
            InProcessBatch,
            EasyPaisaBatch,
            FincaBatch,
        },
        methods: {
            shouldShowTab(tabName) {
                const tab = this.tabs.find((t) => t.name === tabName);
                return tab ? tab.condition === true : false;
            },
            isActiveTab(tabName) {
                return this.activeTabs.includes(tabName);
            },
            setToggle(tabName) {
                this.activeTabs = [];
                this.activeTabs.push(tabName);
            },
            checkPermission(tabName, permissionName) {
                this.can(permissionName).then((result) => {
                    const tab = this.tabs.find((t) => t.name === tabName);
                    if (tab) {
                        tab.condition = result[permissionName] === true;
                        if (tab.condition) {
                            if (!this.firstActiveTab) {
                                this.firstActiveTab = tab.name;
                            }
                            this.setToggle(this.firstActiveTab);
                        }
                    }
                    this.$Progress.finish();
                });
            },
        },
        mounted() {
            this.$Progress.start();
            this.checkPermission("pendingBatch", "pending_batch");
            this.checkPermission("inProcessBatch", "in_process_batch");
            this.checkPermission("easyPaisaBatch", "easypaisa_inprocess_batch");
            this.checkPermission("fincaBatch", "easypaisa_inprocess_batch");
        },
    };
</script>
